module.exports = __webpack_public_path__ + "img/icon_zrtb@2x.546e93c7.png";